import { Link } from 'react-router-dom';

export default function ComplementaryPrograms() {
  const programs = [
    { icon: 'ri-line-chart-line', title: 'Обучение отдела продаж', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh', desc: 'Развитие навыков продаж, работы с возражениями и увеличения конверсии менеджеров.' },
    { icon: 'ri-building-line', title: 'Корпоративное обучение сотрудников', href: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie', desc: 'Комплексные программы обучения для всех категорий персонала компании под бизнес-задачи.' },
    { icon: 'ri-chat-3-line', title: 'Тренинг по переговорам', href: '/prodazhi-i-peregovory/trening-po-peregovoram', desc: 'Жёсткие и мягкие переговоры, работа с манипуляциями, подготовка и стратегия.' },
    { icon: 'ri-gamepad-line', title: 'Командные бизнес-игры', href: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie', desc: 'Игровые форматы для сплочения команды, отработки навыков и моделирования бизнес-ситуаций.' },
    { icon: 'ri-compasses-2-line', title: 'Фасилитация стратегических сессий', href: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya', desc: 'Профессиональная модерация встреч топ-менеджмента для выработки стратегии и решений.' },
    { icon: 'ri-briefcase-4-line', title: 'Консалтинг отдела продаж', href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh', desc: 'Аудит, построение системы продаж, внедрение стандартов и контроль выполнения.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие программы дополняют обучение руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          После обучения руководителей компании чаще всего заказывают смежные программы для усиления эффекта на всех уровнях
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {programs.map((program, i) => (
            <Link
              key={i}
              to={program.href}
              className="bg-white p-6 rounded-xl border border-gray-100 hover:bg-teal-50 hover:border-teal-200 transition-all group cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className={`${program.icon} text-lg text-white`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm mb-1 group-hover:text-teal-700 transition-colors">{program.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed mb-2">{program.desc}</p>
                  <span className="text-teal-600 text-xs font-semibold inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Подробнее
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}